/**
 * A score for display: a whole number, rounded (74.5 shows as 75, 74.4 as
 * 74). The engine keeps one decimal, and the API returns it, but a person
 * reads a score as a whole number - so every screen formats it here and
 * none works a tier out from it.
 */
export function formatScore(score: number): string {
  return String(Math.round(score))
}
